module.exports = __webpack_public_path__ + "static/media/ArtworkInfo2568.407a3015.png";